import { Modify } from '@/types/helpers';
import { AppointRequest, InitialRequest } from '@/types/requests';
import { Question, QuestionConstructor, OptionConstructor } from '@/types/question';
import { ProgressStep } from '@/types/progressStep';
import { ConfigUpdater } from '@/types/config';

export type StepConstructor = Modify<Partial<Step> & Pick<Step, 'stateId' | 'data'>, {
    questions?: QuestionConstructor[];
    values?: OptionConstructor[];
}>

export class Step {
    type = 'flow';
    requestId?: string;
    questions = [] as Question[];
    continueTitle = null as string | null;
    stubFile = null as string | null;
    stateId: string;
    stateIndex = null as number | null;
    app?: string;
    account?: string;
    resetHistory = false;
    historyInvisible = false;
    freezeHistory = false;
    setWindowUrl = null as string | null;
    formAction = null as string | null;
    formMethod = null as string | null;
    noContinue = false;
    noRetryOnError = false;
    startPage = false;
    hasPrint = false;
    prompts?: Record<string, string>;
    reverting = null as string | null;
    form = false;
    pageWidth = null as number | null;
    specificView = false;
    historyContent = {} as Record<string, {form: boolean; clear: boolean; title: string}>;
    error = null as string | null;
    config = null as ConfigUpdater | null;
    info = null as string | null;
    head = null as string | null;
    progress?: ProgressStep;
    expanded = false;
    sidenotes?: Array<Sidenote>;
    historyData = null as HistoryData | null;
    data: AppointRequest | InitialRequest;
    history?: Step[];
    serverTime = null as string | null;

    constructor (props: StepConstructor) {
        Object.assign(this, props || {});
        this.stateId = props.stateId;
        this.data = props.data;
        this.questions = props.questions?.map(question => new Question(question)) || [];
    }
};

export type HistoryData = {
    title: string; value: string;
}

type RedirectStepConstructor = Partial<RedirectStep> & Pick<RedirectStep, 'to'>
export class RedirectStep {
    type = 'redirect';
    to: string;

    constructor (step: RedirectStepConstructor) {
        this.to = step.to;
    }
}

export type MixedStepConstructor = RedirectStepConstructor | StepConstructor

export function newMixedStep (step: MixedStepConstructor) {
    if (step.type === 'redirect') {
        return new RedirectStep(step as RedirectStepConstructor);
    } else {
        return new Step(step as StepConstructor);
    }
}

export type Sidenote = {
    clean: boolean;
    width: string;
    title: string;
}
